module.exports = __webpack_public_path__ + "img/faming3.1b819838.png";